export default __webpack_public_path__ + "static/media/java.a30a167a.jpeg";